import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./actions/user.actions";
import configReducer from "./actions/config.actions";
import collaboratorReducer from "./actions/collaborator.actions";
import formationReducer from "./actions/formation.actions";
import managementReducer from "./actions/management.actions";
import careerManagerReducer from "./actions/careerManager.actions";
import techSkillReducer from "./actions/techSkill.actions";
import potentialMatrixV3Reducer from "./actions/potentialMatrixV3.actions";

export const store = configureStore({
  reducer: {
    user: userReducer,
    config: configReducer,
    collaborator: collaboratorReducer,
    formation: formationReducer,
    management: managementReducer,
    careerManager: careerManagerReducer,
    techSkill: techSkillReducer,
    potentialMatrixV3: potentialMatrixV3Reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
